import { initMapboxForContactPage } from './modules/mapbox';
document.addEventListener('DOMContentLoaded', function () {
  initMapboxForContactPage();
});